var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticStyle: { height: "100%", "background-color": "#1d1d1d" } },
    [
      _c(
        "v-layout",
        { attrs: { xs12: "", column: "", wrap: "", "justify-center": "" } },
        [
          _c(
            "v-flex",
            {
              staticStyle: { "margin-bottom": "15px" },
              attrs: { xs12: "", fluid: "" }
            },
            [
              _c(
                "v-icon",
                { staticStyle: { "font-size": "24px", color: "#643dff" } },
                [_vm._v("fas fa-robot")]
              ),
              _c(
                "span",
                {
                  staticClass: "pl-2 ml-2",
                  staticStyle: {
                    "font-size": "13px",
                    "text-transform": "uppercase",
                    color: "#643dff"
                  }
                },
                [_vm._v("Chatbot")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            { attrs: { row: "", xs12: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs2: "" } },
                [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-size": "13px",
                        "text-transform": "uppercase"
                      }
                    },
                    [_vm._v("Service")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    [
                      _c("v-select", {
                        attrs: {
                          dark: "",
                          items: _vm.services,
                          "persistent-hint": "",
                          "return-object": ""
                        },
                        on: { input: _vm.selectedService },
                        model: {
                          value: _vm.selectService,
                          callback: function($$v) {
                            _vm.selectService = $$v
                          },
                          expression: "selectService"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { staticClass: "mx-3", attrs: { xs2: "" } },
                [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-size": "13px",
                        "text-transform": "uppercase"
                      }
                    },
                    [_vm._v("Type")]
                  ),
                  _vm._v(" "),
                  _c("v-select", {
                    attrs: {
                      dark: "",
                      items: _vm.types,
                      "persistent-hint": "",
                      "return-object": ""
                    },
                    on: { input: _vm.selectedType },
                    model: {
                      value: _vm.selectType,
                      callback: function($$v) {
                        _vm.selectType = $$v
                      },
                      expression: "selectType"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs3: "" } },
                [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-size": "13px",
                        "text-transform": "uppercase"
                      }
                    },
                    [_vm._v("Number of Chat")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    { attrs: { row: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs3: "", sm4: "" } },
                        [
                          _c("v-text-field", {
                            staticClass: "inputPrice",
                            staticStyle: { width: "100px" },
                            attrs: { dark: "", outline: "", "single-line": "" },
                            on: { change: _vm.changedNumberOfCalls },
                            model: {
                              value: _vm.numberOfCalls.value,
                              callback: function($$v) {
                                _vm.$set(_vm.numberOfCalls, "value", $$v)
                              },
                              expression: "numberOfCalls.value"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs3: "", sm3: "" } },
                        [
                          _c(
                            "v-layout",
                            { attrs: { column: "" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "ma-0",
                                  staticStyle: {
                                    "background-color": "#7F5FFF",
                                    width: "25px",
                                    height: "25px"
                                  },
                                  attrs: { fab: "", dark: "" },
                                  on: {
                                    click: function($event) {
                                      _vm.numberOfCalls.value++
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    { staticStyle: { "font-size": "20px" } },
                                    [_vm._v("keyboard_arrow_up")]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "mx-0 mb-0 mt-1",
                                  staticStyle: {
                                    "background-color": "#7F5FFF",
                                    width: "25px",
                                    height: "25px"
                                  },
                                  attrs: { fab: "", dark: "" },
                                  on: {
                                    click: function($event) {
                                      _vm.numberOfCalls.value--
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    { staticStyle: { "font-size": "20px" } },
                                    [_vm._v("keyboard_arrow_down")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-flex", { attrs: { xs5: "" } })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs12: "" } },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    "font-size": "13px",
                    "text-transform": "uppercase"
                  }
                },
                [_vm._v("Character")]
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                [
                  _c(
                    "v-btn",
                    {
                      staticStyle: { "background-color": "#7F5FFF" },
                      attrs: { dark: "", round: "" },
                      on: { click: _vm.selectCharacter }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.selectedCharacter.value || "New Character")
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                [
                  !_vm.selectedCharacter.value
                    ? _c(
                        "v-btn",
                        {
                          staticStyle: { "background-color": "#7F5FFF" },
                          attrs: { dark: "", round: "" },
                          on: { click: _vm.listCharacter }
                        },
                        [_vm._v("Existing character")]
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(_vm.characters, function(character, index) {
                return _c(
                  "v-flex",
                  { key: index },
                  [
                    !_vm.selectedCharacter.value
                      ? _c(
                          "v-btn",
                          {
                            staticStyle: { "background-color": "#7F5FFF" },
                            attrs: { dark: "", round: "" },
                            on: {
                              click: function($event) {
                                return _vm.importCharacter(
                                  _vm.characters[index]
                                )
                              }
                            }
                          },
                          [_vm._v(_vm._s(character.name))]
                        )
                      : _vm._e()
                  ],
                  1
                )
              })
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-24288fe4", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24288fe4","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/story-edit-view/chatbotPanel.vue
// module id = null
// module chunks = 